Vue.mixin({
    methods: {
        format_date(date) {
            if (! date){
                return null;
            }
            
            var dateArray = date.split('-');

            var year = dateArray[0];
            var month = dateArray[1];
            var day = dateArray[2];

            if (year != '0000' && month != '00' && day != '00')
            {
                return day + '/' + month + '/' + year;
            }

            if (year != '0000' && month != '00')
            {
                return month + '/' + year;
            }

            if (year != '0000')
            {
                return year;
            }

            return null;
        }
    }
});